import React from 'react'
import PropTypes from 'prop-types'
import {
  IconFAWrapper,
  ICON_FA_VARIANT_SOLID,
  ICON_FA_VARIANT_REGULAR,
  ICON_FA_VARIANT_LIGHT
} from './IconFAWrapper'

export const IconFATimes = ({
  className,
  variant,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconFAWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      {variant === ICON_FA_VARIANT_SOLID ? (
        // <svg
        //   aria-hidden='true'
        //   focusable='false'
        //   data-prefix='fas'
        //   data-icon='times'
        //   role='img'
        //   viewBox='0 0 352 512'
        // >
        //   <path
        //     shapeRendering='geometricPrecision'
        //     fill='currentColor'
        //     d='M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z'
        //   />
        // </svg>
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='fas'
          data-icon='times'
          role='img'
          viewBox='0 0 9 9'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M8.50446 6.11161C8.62946 6.23661 8.69196 6.38839 8.69196 6.56696C8.69196 6.74554 8.62946 6.89732 8.50446 7.02232L7.59375 7.93304C7.46875 8.05804 7.31696 8.12054 7.13839 8.12054C6.95982 8.12054 6.80804 8.05804 6.68304 7.93304L4.71429 5.96429L2.74554 7.93304C2.62054 8.05804 2.46875 8.12054 2.29018 8.12054C2.11161 8.12054 1.95982 8.05804 1.83482 7.93304L0.924107 7.02232C0.799107 6.89732 0.736607 6.74554 0.736607 6.56696C0.736607 6.38839 0.799107 6.23661 0.924107 6.11161L2.89286 4.14286L0.924107 2.17411C0.799107 2.04911 0.736607 1.89732 0.736607 1.71875C0.736607 1.54018 0.799107 1.38839 0.924107 1.26339L1.83482 0.352678C1.95982 0.227678 2.11161 0.165178 2.29018 0.165178C2.46875 0.165178 2.62054 0.227678 2.74554 0.352678L4.71429 2.32143L6.68304 0.352678C6.80804 0.227678 6.95982 0.165178 7.13839 0.165178C7.31696 0.165178 7.46875 0.227678 7.59375 0.352678L8.50446 1.26339C8.62946 1.38839 8.69196 1.54018 8.69196 1.71875C8.69196 1.89732 8.62946 2.04911 8.50446 2.17411L6.53571 4.14286L8.50446 6.11161Z'
          />
        </svg>
      ) : variant === ICON_FA_VARIANT_REGULAR ? (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='far'
          data-icon='times'
          role='img'
          viewBox='0 0 320 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'
          />
        </svg>
      ) : (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='fal'
          data-icon='times'
          role='img'
          viewBox='0 0 320 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z'
          />
        </svg>
      )}
    </IconFAWrapper>
  )
}

IconFATimes.defaultProps = {
  variant: ICON_FA_VARIANT_SOLID
}

IconFATimes.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    ICON_FA_VARIANT_SOLID,
    ICON_FA_VARIANT_REGULAR,
    ICON_FA_VARIANT_LIGHT
  ]),
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
